import React from "react";
import { useNavigate } from "react-router-dom";

// Style
import {
  FooterWrapper,
  FooterLeftSide,
  FooterRightSide,
  Content,
} from "../../style/LandingPage";

// Images
import logoDark from "../../images/footerLogo.svg";
import logoLight from "../../images/ic_logo_white.svg";
import Nvidia from "../../images/nvidia-inception-program.svg";

// Components
import Button from "../../components/button";

// Language
import { useTranslation } from "react-i18next";

const _isLightTheme = localStorage.getItem('theme') === 'light';
const logo = _isLightTheme ? logoLight : logoDark;

const Footer = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleLink = () => {
    navigate("/register");
  };

  return (
    <FooterWrapper>
      <FooterLeftSide>
        <img src={logo} alt={logo} />
        <div className="badge-wrap">
          <div>
            <h4>{t("footer.desc")}</h4>
            <Button
              title={t("footer.button")}
              color={"secondary"}
              onClick={() => handleLink()}
            />
          </div>
          <img src={Nvidia} width={160} alt={Nvidia} />
        </div>

      </FooterLeftSide>
      <FooterRightSide>
        <Content>
          <h5>{t("footer.mainLink")}</h5>
          <ul>
            <li>
              <a href="/#platform">{t("footer.platform")}</a>
            </li>
            <li>
              <a href="/#services">{t("footer.services")}</a>
            </li>
            <li>
              <a href="/#about">{t("footer.aboutUs")}</a>
            </li>
            <li>
              <a href="/#contact">{t("footer.contactUs")}</a>
            </li>
          </ul>
        </Content>
        <Content>
          <h5>{t("footer.otherLinks")}</h5>
          <ul>
            <li>
              <a href="/privacy">{t("footer.privacyPolicy")}</a>
            </li>
            <li>
              <a href="/terms">{t("footer.termsConditions")}</a>
            </li>
          </ul>
        </Content>
        <Content>
          <h5>{t("footer.contactDetails")}</h5>
          <ul>
            <li>
              <a href="mailto:mail@support.com">sales@smrtstats.com</a>
            </li>
            <li>
              <a>
                13 Honeypark, Dun Laoghaire, <br />Dublin, Ireland
              </a>
            </li>
          </ul>
        </Content>
      </FooterRightSide>
    </FooterWrapper>
  );
};

export default Footer;
